import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

const sharedStyle = StyleSheet.create({
  buttonIcon: {
    color: brand.main.water,
    padding: 2,
  },
  button: {
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOpacity: 0.08,
    shadowOffset: {
      width: 9,
      height: 4,
    },
    shadowRadius: 18,
  },
  option: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    gap: 14,
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: 16,
    height: 16,
  },
  text: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.neutralGrays.graphite,
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 30, // Posizionato sopra l'icona
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  wrapper: {
    position: 'absolute',
    top: 30,
    right: 50,
    zIndex: 2,
    width: 200,
  },
  popup: {
    borderRadius: 32,
    padding: 8,
    gap: 9,
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOpacity: 0.13,
    shadowOffset: {
      width: 14,
      height: 12,
    },
    shadowRadius: 60,
  },
  iconHelp: {
    width: 22,
    height: 22,
  },
});
export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  wrapper: {
    position: 'absolute',
    bottom: 24,
    left: 16,
    zIndex: 2,
  },
  popup: {
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    borderBottomRightRadius: 32,
    padding: 16,
    gap: 9,
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOpacity: 0.13,
    shadowOffset: {
      width: 14,
      height: 12,
    },
    shadowRadius: 60,
    marginLeft: 16,
    marginBottom: 10,
  },
  iconHelp: {
    width: 22,
    height: 22,
  },
});
